<template>
    <div class="container" style="max-height: 100% !important; overflow: hidden">
        <el-row class="mt-4">
            <el-skeleton>
                <template #template>
                    <el-skeleton-item variant="h1" />
                </template>
            </el-skeleton>
            <el-skeleton class="mt-4" style="--el-skeleton-circle-size: 200px">
                <template #template>
                    <el-skeleton-item variant="circle" />
                </template>
            </el-skeleton>
            <el-skeleton class="mt-4" />
            <el-skeleton class="mt-4" style="--el-skeleton-circle-size: 200px">
                <template #template>
                    <el-skeleton-item variant="circle" />
                    <el-skeleton-item variant="circle" class="ms-4" />
                    <el-skeleton-item variant="circle" class="ms-4" />
                </template>
            </el-skeleton>
            <el-skeleton class="mt-4" :rows="20" />
        </el-row>
        <el-dialog :model-value="true" :title="`Login to ${$appName}`" :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false">
            <el-row v-if="$route.query.from">
                <el-alert
                    type="warning"
                    title="Please login before accessing this page"
                    :closable="false"
                    effect="dark"
                    show-icon
                >
                    You have tried to open a protected page in {{ $appName }}. Please login in order to continue.
                </el-alert>
            </el-row>
            <el-row class="mt-4">
                <el-col>
                    <el-alert
                        title="Could not log in!"
                        type="error"
                        :description="errorMessage"
                        show-icon
                        effect="dark"
                        :closable="false"
                        v-if="errorMessage"
                        class="mb-4"
                    />
                    <el-form label-position="top" size="large" :rules="loginRules" :model="loginData" ref="loginForm">
                        <el-form-item label="E-Mail Address" prop="email">
                            <el-input v-model="loginData.email" placeholder="E-Mail Address" />
                        </el-form-item>
                        <el-form-item label="Password" prop="password">
                            <el-input v-model="loginData.password" type="password" placeholder="Password" show-password />
                        </el-form-item>
                    </el-form>
                </el-col>
            </el-row>

            <el-row justify="space-between" align="bottom">
                <div>
                    <el-button size="large" type="primary" @click="tryLogin">Login</el-button>
                </div>
                <div class="text-center">
                    <div class="mb-2">Forgot your password?</div>
                    <el-button plain type="primary" @click="$router.push({name: 'ResetPassword', query: $route.query})">
                        <el-icon class="el-icon--left">
                            <Unlock />
                        </el-icon>
                        Request password reset
                    </el-button>
                </div>
                
            </el-row>
        </el-dialog>
    </div>
</template>

<script>

import {mapActions, mapGetters} from 'vuex'

export default {
    name: 'LoginPage',
    props: {
    },
    data: () => {
        return {
            loginData: {
                email: undefined,
                password: undefined
            },
            errorMessage: undefined,
            loginRules: {
                email: { type: 'email', required: true, message: "Please provide a valid e-mail address" },
                password: { type: 'string', required: true, message: "Password is mandatory" }
            }
        }
    },
    computed: {
        ...mapGetters('auth', ['isLoggedIn'])
    },
    head: {
        title: 'Login'
    },
    methods: {
        ...mapActions('auth', ['login']),

        async tryLogin () {
            try{
                await this.$refs.loginForm.validate()
            } catch {
                this.errorMessage = "Please enter your credentials"
                return
            }
            
            this.login({email: this.loginData.email, password: this.loginData.password})
            .then(() => {
                this.errorMessage = undefined

                if (this.$route.query.from !== undefined) {
                    this.$router.push({'path': this.$route.query.from})
                } else {
                    this.$router.push({'name': 'HomePage'})
                }
            })
            .catch (error => {
                this.errorMessage = error.response?.data?.message || "Unknown error"
                console.error (error)
            })
        }
    },
    beforeMount () {
        // Just add a guard so a logged in user doesn't see this page.
        if (this.isLoggedIn) {
            if (this.$route.query.from !== undefined) {
                this.$router.push({'path': this.$route.query.from})
            } else {
                this.$router.push({'name': 'HomePage'})
            }
        }
    },
    updated () {
    }
}
</script>